import React from 'react'

const CurrencyTable = ({ title, items = [] }) => {
  return (
    <div className='currency-chart-ma__table-wrapper'>
      <table className='currency-chart-ma__table'>
        <caption className='currency-chart-ma__table-title'>{title}</caption>
        <thead className='currency-chart-ma__table-head'>
          <tr className='currency-chart-ma__table-row'>
            <th>Дата</th>
            <th>Курс ЦБ РФ</th>
          </tr>
        </thead>
        <tbody>
          {items.map(({ date, value }, index) => {
            return <tr className='currency-chart-ma__table-row' key={index}>
              <td>{date}</td>
              <td>{value}</td>
            </tr>
          })}
        </tbody>
      </table>
    </div>
  )
}

export default CurrencyTable
